import type { ReactNode } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { useTranslation } from '../../hooks/useTranslation';

// Confirmación de una acción. Cancelar (light) a la izquierda, confirmar a la
// derecha: primary, o danger si la acción borra o no se puede deshacer.
// Ver design.md › Modales.
const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel,
  cancelLabel,
  isDestructive = false,
  isLoading = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  children?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  isDestructive?: boolean;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        {children ? <ModalBody>{children}</ModalBody> : null}
        <ModalFooter>
          <Button variant='light' onPress={onClose} isDisabled={isLoading}>
            {cancelLabel ?? t('Cancelar')}
          </Button>
          <Button
            color={isDestructive ? 'danger' : 'primary'}
            onPress={onConfirm}
            isLoading={isLoading}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;
